<template>
  <div v-if="inital">
    <notifications></notifications>
    <div v-if="user" :class="{ 'nav-open': $sidebar.showSidebar }">
      <order v-if="card === 'order'" :id="$route.query.id" />
      <group v-if="card === 'group'" :id="$route.query.id" />
      <draw v-if="card === 'draw'" :id="$route.query.id" />
      <news v-if="card === 'new'" :id="$route.query.id" />
      <production v-if="card === 'draw_production'" :id="$route.query.id" />
      <router-view></router-view>
      <list-item v-if="modalName" :modalName="modalName" />
    </div>
    <div v-else>
      <login />
    </div>
  </div>
</template>
<script>
import login from "./pages/Login";
import order from "./components/Card/Order";
import group from "./components/Card/Group";
import draw from "./components/Card/Draw";
import news from "./components/Card/News";
import production from "./components/Card/Draw/Production";
import ListItem from "./components/Modals/ListItem";

import { mapState } from "vuex";

export default {
  data: () => ({
    inital: false,
    audio: null,
  }),
  components: {
    order,
    group,
    news,
    draw,
    production,
    login,
    ListItem,
  },
  computed: {
    ...mapState(["user", "modalName"]),
    card: {
      get() {
        if (
          this.$route &&
          this.$route.query &&
          this.$route.query.card &&
          this.$route.query.id
        ) {
          return this.$route.query.card;
        }
      },
    },
  },
  methods: {
    pushNotifiction(message) {
      if (this.$notification) {
        this.$notification.show(
          "Glamour Boutique",
          {
            body: message,
            icon: "@/assets/img/logo.png",
          },
          {}
        );
      }
    },
    initSocket() {
      this.$socket.$subscribe("laravel_database_order-admin", (payload) => {
        if (!payload.is_update || payload.is_update === false) {
          this.$notify({
            title: "Заказ #" + payload.order.id,
            message: "У вас новый заказ",
            icon: "ti-shopping-cart",
            horizontalAlign: "right",
            verticalAlign: "top",
            type: "info",
          });
          this.pushNotifiction("Заказ #" + payload.order.id);
          this.audio.play();
        }
        this.$store.dispatch("setNewOrder", Date.now());
      });
    },
  },
  mounted() {
    this.audio = new Audio("./notify.mp3");
    this.$loading(true);
    this.$http
      .get("admin/info")
      .then((response) => {
        this.$store.dispatch("setUser", response.data);
        this.initSocket();
      })
      .catch(() => {})
      .finally(() => {
        this.inital = true;
        setTimeout(() => {
          this.$loading(false);
        }, 400);
      });
  },
  watch: {
    modalName(val) {
      if (val) {
        setTimeout(() => {
          this.$modal.show(val.model);
        }, 10);
      }
    },
  },
};
</script>

<style lang="scss">
.vue-notifyjs.notifications {
  .alert {
    z-index: 10000;
  }
  .list-move {
    transition: transform 0.3s, opacity 0.4s;
  }
  .list-item {
    display: inline-block;
    margin-right: 10px;
  }
  .list-enter-active {
    transition: transform 0.2s ease-in, opacity 0.4s ease-in;
  }
  .list-leave-active {
    transition: transform 1s ease-out, opacity 0.4s ease-out;
  }

  .list-enter {
    opacity: 0;
    transform: scale(1.1);
  }
  .list-leave-to {
    opacity: 0;
    transform: scale(1.2, 0.7);
  }
}
</style>
